const archiveModule = document.querySelector('.archive-module');

if (archiveModule) {
  const urlParams = ['locations', 'types', 'audiences', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    locations: getCheckedData(parent, 'locations'),
    types: getCheckedData(parent, 'types'),
    audiences: getCheckedData(parent, 'audiences'),
  });

  // Filter click
  attachEvent('.archive-module .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.archive-module');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.archive-module .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.archive-module');
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page, urlParams, getExtraFormDataInput(parent));
  });
}
